export default {
	allTripAddresses: [],
	loading: false,
	errors: {
		invalidName: false,
		invalidPostalCode: false,
		name: false,
		street: false,
		postalPlace: false,
		postalCode: false,
		countryCode: false,
		id: ''
	},
	globalLocations: {}
};
